import type { ReactNode } from "react";
import "./CommunityPreviewStage.scss";

export interface CommunityPreviewStageProps {
  children: ReactNode;
  className?: string;
}

/** 预览区：会改 configData 的控件禁点不置灰；查看/切换类操作见 community-preview-interactive */
export default function CommunityPreviewStage({
  children,
  className = "",
}: CommunityPreviewStageProps) {
  return (
    <div
      className={`community-preview-stage ${className}`.trim()}
      aria-readonly="true"
    >
      <div className="community-preview-stage__content">{children}</div>
    </div>
  );
}
